"use client";

import { useContentfulInspectorMode } from "@scott/contentful/live-preview-init";
import type { BlockInspectorProps } from "../../lib/inspector";
import { TaglineSection, type TaglineSectionProps } from "./tagline-section";

export type TaglineSectionInspectorProps = BlockInspectorProps;

export function TaglineSectionPreview(props: Readonly<TaglineSectionProps>) {
  const containerInspector = useContentfulInspectorMode({
    entryId: props.sys?.id,
  });

  const textInspector = useContentfulInspectorMode({
    entryId: props.text?.sys?.id,
    locale: props.text?.sys?.locale,
  });

  return (
    <TaglineSection
      {...props}
      inspectorProps={{
        container: containerInspector({ fieldId: "internalName" }) ?? undefined,
        text: textInspector({ fieldId: "text" }) ?? undefined,
      }}
    />
  );
}
